module.exports = __webpack_public_path__ + "static/detailgateway_font-b83e73a24c0bc2f1c2821397ecfa3677.png";